import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Attachment, AttachmentPayload } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MediaApiService {
  constructor(private http: HttpClient) {}

  getAttachment(mediaId: string): Observable<Attachment> {
    return this.http.get<Attachment>(`/media/${mediaId}`);
  }

  createAttachment(params: AttachmentPayload): Observable<Attachment> {
    return this.http.post<Attachment>(`/media`, params);
  }

  updateAttachment(
    mediaId: string,
    params: Partial<Attachment>
  ): Observable<Attachment> {
    return this.http.patch<Attachment>(`/media/${mediaId}`, params);
  }

  deleteAttachment(mediaId: string): Observable<Attachment> {
    return this.http.delete<Attachment>(`/media/${mediaId}`);
  }
}
